import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getUsers = async () => {
  try {
    const response = await axios.get(`${base_url}student`, config);
    return response.data;
  } catch (error) {
    throw new Error(error);
  }
};

const getaUser = async (id) => {
  const response = await axios.get(`${base_url}student/${id}`, config);

  return response.data;
};


const createUser = async (student) => {
  const response = await axios.post(`${base_url}student`, student, config);

  return response.data;
};

const studentService = {
  getUsers,
  getaUser,
  createUser
};

export default studentService;
